import { createFileRoute } from '@tanstack/react-router';
import { FinanceBudgetsScreen } from '../../screens/finance/Budgets';

export const Route = createFileRoute('/finance/budgets')({
  component: FinanceBudgetsScreen,
});
